<template>
    <div class="card">
        <div class="card-header">
            業務カレンダー
        </div>
        <v-flex class="card-body p-0">
            <v-sheet height="120">
                <v-toolbar color="white" flat>
                    <v-toolbar-title class="mx-auto">{{ title }}</v-toolbar-title>
                </v-toolbar>
                <v-toolbar color="white" flat>
                    <v-btn @click="prev" color="darken-2" depressed fab small text>
                        <
                    </v-btn>
                    <v-btn @click="next" color="darken-2" depressed fab small text>
                        >
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-menu bottom right>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    color="darken-2"
                                    depressed
                                    v-on="on"
                            >
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right>arrow_drop_down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile @click="type = 'month'">
                                <v-list-tile-title>月</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="type = 'week'">
                                <v-list-tile-title>週</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="type = 'day'">
                                <v-list-tile-title>日</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-sheet>
            <v-sheet height="400">
                <v-calendar
                        :day-format="timestamp => new Date(timestamp.date).getDate()"
                        :end="end"
                        :month-format="timestamp => (new Date(timestamp.date).getMonth() + 1)"
                        :now="today"
                        :start="start"
                        :type="type"
                        color="primary"
                        locale="ja-jp"
                        ref="calendar"
                        v-model="start"
                        @click:date="clickDate"
                >
                    <template v-slot:day="{ date }">
                        <template v-for="event in eventsMap[date]">
                            <v-menu
                                    :close-on-content-click="false"
                                    :key="getEventKey(event)"
                                    full-width
                                    offset-x
                                    v-model="event.open"
                            >
                                <template v-slot:activator="{ on }">
                                    <div
                                            :class="getEventClassMonthly(event)"
                                            v-html="event.title"
                                            v-on="on"
                                            v-ripple
                                    ></div>
                                </template>
                                <popup-component
                                        :event="event"
                                        @updateEventCompletionReport="updateEventCompletionReport"
                                />
                            </v-menu>
                        </template>
                    </template>
                    <!-- the events at the bottom (timed) -->
                    <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                        <template v-for="event in eventsMap[date]">
                            <v-menu
                                    :close-on-content-click="false"
                                    :key="getEventKey(event)"
                                    full-width
                                    offset-x
                                    v-model="event.open"
                            >
                                <template v-slot:activator="{ on }">
                                    <div
                                            :class="getEventClass(event)"
                                            :style="{ top: timeToY(event.start_time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                                            v-html="event.title"
                                            v-on="on"
                                            v-ripple
                                    ></div>
                                </template>
                                <popup-component
                                        :event="event"
                                        @updateEventCompletionReport="updateEventCompletionReport"
                                />
                            </v-menu>
                        </template>
                    </template>
                </v-calendar>
            </v-sheet>
        </v-flex>
    </div>
</template>

<script>
    import PopupComponent from './PopupComponent';
    import moment from "moment";
    import {EnumsMixin} from '../../../mixins/enums';

    export default {
        name: "ArrangementCalendarComponent",
        components: {
            PopupComponent,
        },
        mixins: [
            EnumsMixin,
        ],
        data() {
            return {
                today: moment().format('YYYY-MM-DD'),
                typeToLabel: {
                    month: '月',
                    week: '週',
                    day: '日',
                },
                events: [],
                type: 'month',
                start: null,
                end: null,
            };
        },
        created() {
            this.start = moment().format('YYYY-MM-DD');
        },
        updated() {
            this.$refs.calendar.scrollToTime('08:00');
        },
        computed: {
            title() {
                return moment(this.start).format('YYYY年MM月');
            },
            eventsMap() {
                const map = {};
                this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
                return map
            },
        },
        methods: {
            setToday() {
                this.focus = this.today
            },
            prev() {
                this.$refs.calendar.prev()
            },
            next() {
                this.$refs.calendar.next()
            },
            getEventKey(event) {
                return event.arrangement.id + event.date;
            },
            getEventClassMonthly(event) {
                if (!event.completion_report) {
                    return 'my-event not_submitted';
                }
                if (event.completion_report.completion_report_status_type == '02') {
                    return 'my-event rejected';
                }

                return 'my-event success';
            },
            getEventClass(event) {
                if (!event.completion_report) {
                    return 'my-event with-time not_submitted';
                }
                if (event.completion_report.completion_report_status_type == '02') {
                    return 'my-event with-time rejected';
                }

                return 'my-event with-time success';
            },
            getEvents(date) {
                // 取得範囲を決定
                let baseDate = moment(date);
                let startDate = baseDate.subtract(1, 'months').format('YYYY-MM-01');
                baseDate = moment(date);
                let endDate = baseDate.add(1, 'months').endOf('month').format("YYYY-MM-DD");

                // 配置枠を取得する
                let param = {
                    'arrangement': {
                        'corporate_id': this.$store.state.auth.corporate_id,
                        'date_from': startDate,
                        'date_to': endDate
                    }
                };
                let seqId = this.$root.startApiRequest();
                appUtil.postAction('/api/arrangements/arrangement/search', param)
                    .then(response => {
                        let arrangementFrames = response.data.arrangementFrames;
                        // 既存のイベントを破棄する
                        this.events = [];

                        // イベントを追加する
                        arrangementFrames.forEach(arrangementFrame => {
                            let arrangement = arrangementFrame.arrangement;
                            let date = moment(arrangement.date).format('YYYY-MM-DD');
                            let startTime = arrangement.work_start_time;
                            let endTime = arrangement.work_end_time;

                            // 時間・分に分割
                            let startTimeHour = startTime.slice(0, 2);
                            let startTimeMinute = startTime.slice(-2);
                            let endTimeHour = endTime.slice(0, 2);
                            let endTimeMinute = endTime.slice(-2);

                            // 日をまたいでいるか判定する
                            let isOverStartTime = (startTimeHour > 24);
                            let isOverEndTime = (endTimeHour > 24);
                            let isLimitEndTime = (endTimeHour == 48);

                            // 日をまたがない場合
                            if (!isOverStartTime && !isOverEndTime) {
                                let event = this.convertArrangementFrameToEvent(arrangementFrame, date, startTime, endTime, true);
                                this.events.push(event);
                            }
                            // 終了時間が翌日の場合
                            if (!isOverStartTime && isOverEndTime) {
                                let event1 = this.convertArrangementFrameToEvent(arrangementFrame, date, startTime, '23:59', false);
                                this.events.push(event1);

                                let nextDate = moment(date).add(1, 'day').format('YYYY-MM-DD');
                                let formattedEndTime = (endTimeHour - 24) + ':' + endTimeMinute;
                                if (isLimitEndTime) {
                                    formattedEndTime = '23:59';
                                }
                                let event2 = this.convertArrangementFrameToEvent(arrangementFrame, nextDate, '00:00', formattedEndTime, true);
                                this.events.push(event2);
                            }
                            // 開始時間・終了時間が翌日の場合
                            if (isOverStartTime && isOverEndTime) {
                                let nextDate = moment(date).add(1, 'day').format('YYYY-MM-DD');
                                let formattedStartTime = (startTimeHour - 24) + ':' + startTimeMinute;
                                let formattedEndTime = (endTimeHour - 24) + ':' + endTimeMinute;
                                if (isLimitEndTime) {
                                    formattedEndTime = '23:59';
                                }
                                let event = this.convertArrangementFrameToEvent(arrangementFrame, nextDate, formattedStartTime, formattedEndTime, true);
                                this.events.push(event);
                            }

                        });
                    })
                    .finally(() => {
                        this.$root.endApiRequest(seqId);
                    });
            },
            convertArrangementFrameToEvent(arrangementFrame, date, startTime, endTime, displayUploadCompletionReports) {
                //配置を取得
                let arrangement = arrangementFrame.arrangement;
                let eventDate = moment(date).format('YYYY-MM-DD');

                //現場を取得
                let site = arrangement.site;

                // 完了届を取得
                let completionReport = null;
                if (arrangementFrame.completion_report_relation_arrangement_frame) {
                    completionReport = arrangementFrame.completion_report_relation_arrangement_frame.completion_report;
                }

                // 時間を算出
                let eventStartTime = moment(startTime, 'HH:mm');
                let eventEndTime = moment(endTime, 'HH:mm');
                let duration = eventEndTime.diff(eventStartTime, 'minutes');

                return {
                    title: arrangement.site.name,
                    date: eventDate,
                    start_time: startTime,
                    end_time: endTime,
                    duration: duration,
                    site: site,
                    arrangement: arrangement,
                    arrangement_frame: arrangementFrame,
                    completion_report: completionReport,
                    open: false,
                    displayUploadCompletionReports: displayUploadCompletionReports,
                };
            },
            updateEventCompletionReport: function (event) {
                let completionReport = event.completion_report;
                this.events.forEach(target => {
                    if (target.arrangement_frame.id == event.arrangement_frame.id) {
                        target.completion_report = completionReport;
                    }
                });
            },
            clickDate: function (event) {
                this.type = 'day';
            }
        },
        watch: {
            start: {
                handler: function (val, oldVal) {
                    let newDate = moment(val);
                    let oldDate = moment(oldVal);
                    let diffMonth = newDate.diff(oldDate, 'month');

                    // 月が変わった場合はデータを再取得
                    if (diffMonth !== 0) {
                        this.getEvents(val);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    v-layout {

    }

    .my-event {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 2px;
        color: #ffffff;
        border: 1px solid #1867c0;
        width: 100%;
        font-size: 12px;
        padding: 3px;
        cursor: pointer;
        margin-bottom: 1px;
    }

    .my-event.with-time {
        position: absolute;
        margin-right: 0;
    }

    .my-event.not_submitted {
        background-color: #1976d2 !important
    }

    .my-event.success {
        background-color: #4caf50 !important
    }

    .my-event.rejected {
        background-color: #ff5252 !important
    }

</style>